import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import MySpiner from '../../../../UI/spiner/MySpiner'
import MyButton from '../../../../UI/form/MyButton'
import { getBoxFilePassportAPI } from '../../../../../api/pack/boxAPI'
import { Buffer } from 'buffer'

const BoxFiles = ({ boxId, setOpen }) => {

    const [result, setResult] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        if (result) {
            getFile()
        }
    }, [result])

    const getQrs = (typeFile) => {
        setError('')
        setLoading (true)
        getBoxFilePassportAPI({ 
            boxId: boxId,
            typeFile: typeFile ? typeFile : null
        }).then(data => {
            setResult(data)
            setLoading (false)
        }).catch(e => {
            setError(responseError(e))
            setLoading (false)
        })
    }

    const getFile = () => {
        const buffer = Buffer.from(result.file);
        const blob = new Blob([buffer]);

        // const name = type && type === 'barcode' ? "штрих-коди на коробку в партії.zip" : "qr-коди на коробку в партії.zip"
        const name = result.fileName
                                   
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);

        setResult('')

        setOpen(false)
    }

  return (
    <div>
        <p className='packResultBlock__text'>Буде отриманий файл з паспортом цієї коробки з вписаними серіями всередину</p>

        {
            loading ?
                <MySpiner />
            : ''
        }

        {
            error ?
                <div className='error'>
                    { error }
                </div>
            : ''
        }

        
        <MyButton
            size='md'
            onClick={getQrs}
            disabled={loading ? true : false}
        >
            Сформувати паспорт (PDF)
        </MyButton>
        <br />
        <MyButton
            size='md'
            onClick={e => getQrs('docx')}
            disabled={loading ? true : false}
        >
            Сформувати паспорт (DOCX)
        </MyButton>
    </div>
  )
}

export default BoxFiles